export const routes = [
  {
    name: "Getting Started",
    pages: [
      {
        name: "Installation",
        route: "installation",
      },
      {
        name: "Installation with CLI",
        route: "installation-with-cli",
      },
      {
        name: "License",
        route: "license",
      },
      {
        name: "What is Tailwind CSS",
        route: "what-is-tailwind-css",
      },
      {
        name: "Release Notes",
        route: "release-notes",
      },
    ],
  },
  {
    name: "Upgrade Guide",
    pages: [
      {
        name: "v2 Migration Guide",
        route: "2.x-migration-guide",
      },
    ],
  },
  {
    name: "Integration Guide",
    pages: [
      {
        name: "Next.js",
        route: "guide/next",
      },
      {
        name: "Create React App",
        route: "guide/cra",
      },
      {
        name: "Remix",
        route: "guide/remix",
      },
      {
        name: "Vite",
        route: "guide/vite",
      },
      {
        name: "Astro",
        route: "guide/astro",
      },
      {
        name: "Gatsby",
        route: "guide/gatsby",
      },
    ],
  },
  {
    name: "Customization",
    pages: [
      {
        name: "Theming",
        route: "theming",
      },
      {
        name: "Colors",
        route: "colors",
      },
      {
        name: "Fonts",
        route: "fonts",
      },
      {
        name: "Shadows",
        route: "shadows",
      },
      {
        name: "Screens",
        route: "screens",
      },
    ],
  },
  {
    name: "Components",
    pages: [
      {
        name: "Accordion",
        route: "accordion",
      },
      {
        name: "Alert",
        route: "alert",
      },
      {
        name: "Avatar",
        route: "avatar",
      },
      {
        name: "Badge",
        route: "badge",
      },
      {
        name: "Breadcrumbs",
        route: "breadcrumbs",
      },
      {
        name: "Button",
        route: "button",
      },
      {
        name: "Button Group",
        route: "button-group",
      },
      {
        name: "Card",
        route: "card",
      },
      {
        name: "Chip",
        route: "chip",
      },
      {
        name: "Collapse",
        route: "collapse",
      },
      {
        name: "Carousel",
        route: "carousel",
      },
      {
        name: "Dialog",
        route: "dialog",
      },
      {
        name: "Drawer",
        route: "drawer",
      },
      {
        name: "Footer",
        route: "footer",
      },
      {
        name: "Form",
        route: "form",
      },
      {
        name: "Gallery",
        route: "gallery",
      },
      {
        name: "Icon Button",
        route: "icon-button",
      },
      {
        name: "Image",
        route: "img",
      },
      {
        name: "List",
        route: "list",
      },
      {
        name: "Menu",
        route: "menu",
      },
      {
        name: "Mega Menu",
        route: "mega-menu",
      },
      {
        name: "Modal",
        route: "modal",
      },
      {
        name: "Navbar",
        route: "navbar",
      },
      {
        name: "Popover",
        route: "popover",
      },
      {
        name: "Progress Bar",
        route: "progress-bar",
      },
      {
        name: "Pagination",
        route: "pagination",
      },
      {
        name: "Rating Bar",
        route: "rating-bar",
      },
      {
        name: "Sidebar",
        route: "sidebar",
      },
      {
        name: "Skeleton",
        route: "skeleton",
      },
      {
        name: "Slider",
        route: "slider",
      },
      {
        name: "Speed Dial",
        route: "speed-dial",
      },
      {
        name: "Spinner",
        route: "spinner",
      },
      {
        name: "Stepper",
        route: "stepper",
      },
      {
        name: "Tabs",
        route: "tabs",
      },
      {
        name: "Table",
        route: "table",
      },
      {
        name: "Timeline",
        route: "timeline",
      },
      {
        name: "Tooltip",
        route: "tooltip",
      },
      {
        name: "Typography",
        route: "typography",
      },

      {
        name: "Video",
        route: "video",
      },
    ],
  },
  {
    name: "Forms",
    pages: [
      {
        name: "Checkbox",
        route: "checkbox",
      },
      {
        name: "Input",
        route: "input",
      },
      {
        name: "Input Number",
        route: "input-number",
      },
      {
        name: "Input Phone",
        route: "input-phone",
      },
      {
        name: "Radio Button",
        route: "radio-button",
      },
      {
        name: "Select",
        route: "select",
      },
      {
        name: "Switch",
        route: "switch",
      },
      {
        name: "Textarea",
        route: "textarea",
      },
    ],
  },
  {
    name: "Web 3.0 Components",
    pages: [
      {
        name: "Crypto Login",
        route: "crypto/crypto-login",
      },
      {
        name: "Crypto Card",
        route: "crypto/crypto-card",
      },
      {
        name: "Crypto Chart",
        route: "crypto/crypto-chart",
      },
      {
        name: "Crypto Modal",
        route: "crypto/crypto-modal",
      },
      {
        name: "Crypto Table",
        route: "crypto/crypto-table",
      },
    ],
  },
  {
    name: "Plugins",
    pages: [
      {
        name: "Algolia Search",
        route: "plugins/algolia-search",
      },
      {
        name: "Charts",
        route: "plugins/charts",
      },
      {
        name: "Clipboard",
        route: "plugins/clipboard",
      },
      {
        name: "Date Picker",
        route: "plugins/date-picker",
      },
      {
        name: "WSSIWYG Editor",
        route: "plugins/text-editor",
      },
    ],
  },
];
